import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function LegalNotice() {
  return (
    <Container className="py-5">
      <Row>
        <Col>
          <h1 className="mb-4">Mentions Légales</h1>
          <p className="lead">Dernière mise à jour : 11 mai 2025</p>

          <section className="mb-5">
            <h2>Éditeur du site</h2>
            <p>
              <strong>Raison sociale</strong> : All Diffusion SNC
            </p>
            <p>
              <strong>Forme juridique</strong> : Société en Nom Collectif
              Limitée
            </p>
            <p>
              <strong>Siège social</strong> : rue du Château 13, 5190
              Jemeppe-sur-Sambre, Belgique
            </p>
            <p>
              <strong>Numéro d'entreprise</strong> : 1016199219
            </p>
            <p>
              <strong>TVA</strong> : BE1016199219
            </p>
            <p>
              <strong>Personnes responsables</strong> : Sébastien Gramtinne,
              Lyam Gramtinne
            </p>
            <p>
              <strong>Email de contact</strong> :{" "}
              <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>
            </p>
          </section>

          <section className="mb-5">
            <h2>Activité</h2>
            <p>
              BoxPlaisir est une boutique en ligne spécialisée dans la vente de
              box thématiques pour offrir ou se faire plaisir.
            </p>
          </section>

          <section className="mb-5">
            <h2>Hébergement</h2>
            <p>
              <strong>Hébergeur</strong> : OVH
            </p>
            <p>
              <strong>Adresse</strong> : 2 rue Kellermann - 59100 Roubaix -
              France
            </p>
          </section>

          <section className="mb-5">
            <h2>Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments constituant le site BoxPlaisir.be (textes,
              graphismes, logiciels, photographies, images, vidéos, sons, plans,
              noms, logos, marques, créations et œuvres protégeables diverses,
              bases de données, etc.) ainsi que le site lui-même, relèvent des
              législations belges et internationales sur le droit d'auteur et la
              propriété intellectuelle.
            </p>
            <p>
              Ces éléments sont la propriété exclusive de All Diffusion SPRL.
              L'internaute reconnaît et accepte que l'utilisation du site
              BoxPlaisir.be ne lui confère aucun droit de propriété sur tout ou
              partie de ces éléments.
            </p>
          </section>

          <section className="mb-5">
            <h2>Protection des données personnelles</h2>
            <p>
              Les informations recueillies sur ce site sont traitées par All
              Diffusion SPRL, responsable de traitement, pour la gestion de sa
              clientèle et de ses prospects.
            </p>
            <p>
              Conformément à la loi belge relative à la protection des personnes
              physiques à l'égard des traitements de données à caractère
              personnel et au Règlement Général sur la Protection des Données
              (RGPD), vous disposez d'un droit d'accès, de rectification,
              d'effacement, de limitation, de portabilité et d'opposition aux
              informations qui vous concernent, que vous pouvez exercer en vous
              adressant à :{" "}
              <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>.
            </p>
            <p>
              Pour plus d'informations, consultez notre{" "}
              <a href="/privacy-policy">Politique de confidentialité</a>.
            </p>
          </section>

          <section className="mb-5">
            <h2>Cookies</h2>
            <p>
              Le site BoxPlaisir.be utilise des cookies pour améliorer
              l'expérience utilisateur. Pour en savoir plus, consultez notre{" "}
              <a href="/privacy-policy">Politique de confidentialité</a>.
            </p>
          </section>

          <section className="mb-5">
            <h2>Loi applicable et juridiction</h2>
            <p>
              Les présentes mentions légales sont soumises au droit belge. En
              cas de litige, les tribunaux belges seront seuls compétents.
            </p>
          </section>
        </Col>
      </Row>
    </Container>
  );
}

export default LegalNotice;
